import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {FilterListPipe} from './pipes/filter-list.pipe';
import {NgbDateParserFormatter, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {AreaSelectionComponent} from './components/area-selection/area-selection.component';
import {HttpClientModule} from "@angular/common/http";
import {FormsModule} from "@angular/forms";
import {ProductsComponent} from './components/products/products.component';
import {ParametersComponent} from './components/parameters/parameters.component';
import {ShoppingCartComponent} from './components/shopping-cart/shopping-cart.component';
import {LoaderComponent} from './components/loader/loader.component';
import {MaintenanceComponent} from './components/maintenance/maintenance.component';
import {
  RemainingSessionTimeButtonComponent
} from './components/remaining-session-time-button/remaining-session-time-button.component';
import {MapComponent} from './components/map/map.component';
import {LoginComponent} from './components/login/login.component';
import {HelpComponent} from './components/help/help.component';
import {SettingsComponent} from './components/settings/settings.component';
import {ExtendSessionComponent} from './components/extend-session/extend-session.component';

import {registerLocaleData} from "@angular/common";
import localeDe from '@angular/common/locales/de';
import {CustomDateParserFormatter} from "./var/custom-date-parser-formatter";

registerLocaleData(localeDe, 'de');

@NgModule({
  declarations: [
    AppComponent,
    FilterListPipe,
    AreaSelectionComponent,
    ProductsComponent,
    ParametersComponent,
    ShoppingCartComponent,
    LoaderComponent,
    MaintenanceComponent,
    RemainingSessionTimeButtonComponent,
    MapComponent,
    LoginComponent,
    HelpComponent,
    SettingsComponent,
    ExtendSessionComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    FormsModule
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'de-DE'},
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
